module.exports = __webpack_public_path__ + "img/Azrtx b  oaxrd   – 2.d15d7b65.png";